import { render, staticRenderFns } from "./TestCalls.vue?vue&type=template&id=8dec7622&"
import script from "./TestCalls.vue?vue&type=script&lang=js&"
export * from "./TestCalls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports